import { IconButton, Modal, Tooltip } from "@material-ui/core";
import React, { Fragment, useState } from "react";
import PrintIcon from "@material-ui/icons/Print";
import CloseIcon from "@material-ui/icons/Close";
import { PrintRefunds } from "./PrintRefunds";

const no_op = () => {};
export default function RefundsListActions({ data, receipt, admision, refreshList = no_op }) {
  console.log("data refund list",data);
  
  const {data: {original: {valor_devolucion, num_devolucion_recibo, motivo_devolución}}} = data; 
  const [openModal, setOpenModal] = useState(false);
  
  const printReceiptData = () => {
    setOpenModal(true);
    PrintRefunds({receipt, admision, valor_devolucion: parseInt(valor_devolucion), num_devolucion_recibo, motivo_devolución});
  };

  return (
    <Fragment>
      <td role="cell">
        <Tooltip title="Imprimir Recibo de Caja">
          <IconButton
            aria-label="unable"
            style={{ padding: 2 }}
            onClick={() => {
              printReceiptData();
            }}
          >
            <PrintIcon />
          </IconButton>
        </Tooltip>
      </td>
      <Modal
        open={openModal}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "120%", margin: 10 }}
        >
          <IconButton
            style={{ float: "right" }}
            onClick={() => {
              setOpenModal(false);
            }}
          >
            <CloseIcon />
          </IconButton>
          <iframe id="pdfV" width="1000" height="600"></iframe>
        </div>
      </Modal>
    </Fragment>
  )
}
